import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Moment from 'react-moment';
import selecionaManutencaoVeiculo from '../../actions/manutencao-veiculo/seleciona-manutencao-veiculo';
import moment from 'moment'
import DetalhesManutencaoVeiculo from './DetalhesManutencaoVeiculo';
import alterarExibicaoDetalhamentoManutencaoVeiculo from '../../actions/manutencao-veiculo/alterarExibicaoDetalhamentoManutencaoVeiculo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import { formatarReal } from '../../util/numberUtil';

export class ManutencaoVeiculo extends Component {

    exibirIcone () {
        if (this.props.manutencaoVeiculo.exibirDetalhe) {
            return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoManutencaoVeiculo(this.props.manutencaoVeiculo)}>
            &#xE5C7;</i>
        }
        return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoManutencaoVeiculo(this.props.manutencaoVeiculo)}>&#xE5C5;</i>
    }

    selecionaManutencaoVeiculo() {
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'tipoOcorrencia', this.props.manutencaoVeiculo.tipoOcorrencia);
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'ocorrencia', this.props.manutencaoVeiculo.ocorrencia);        
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'valorTotalGasto', this.props.manutencaoVeiculo.valorTotalGasto);

        this.props.selecionarDataOcorrencia(moment(this.props.manutencaoVeiculo.dataOcorrencia).toDate());
        this.props.selecionaManutencaoVeiculo(this.props.manutencaoVeiculo);
    }

    limparSelecaoManutencaoVeiculo() {
        this.props.limparSelecaoManutencaoVeiculo();
    }

    render() {
        return (
            <div className="geral">
                <div className={`${this.props.manutencaoVeiculo.selecionado ? 'resumo-laranja' : 'resumo'}`}>
                    <div className="row">
                        <div className="col-md-1 col-lg-1 col-xl-1" onClick={() => this.props.alterarExibicaoDetalhamentoManutencaoVeiculo(this.props.manutencaoVeiculo)} style={{ cursor: 'pointer' }}>
                            {this.exibirIcone()}
                        </div>
                        <div className="col"><Moment format="DD/MM/YYYY">{this.props.manutencaoVeiculo.dataOcorrencia}</Moment></div>
                        <div className="col">{this.props.manutencaoVeiculo.registradoPor}</div>
                        <div className="col"><Moment format="DD/MM/YYYY">{this.props.manutencaoVeiculo.dataCadastro}</Moment></div>
                        <div className="col">{this.props.manutencaoVeiculo.tipoOcorrencia}</div>
                        <div className="col">{this.props.manutencaoVeiculo.valorTotalGasto ? formatarReal(this.props.manutencaoVeiculo.valorTotalGasto) : ''}</div>
                        <Autorizacao
                            perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                            <div className="col align-self-center text-right">
                                <div className="acoes">
                                    <div className="botoes">
                                        <button type="button" className="btn btn-excluir"
                                                data-toggle="modal" key={this.props.manutencaoVeiculo.id}
                                                data-target="#modalConfirmacaoExclusaoManutencaoVeiculo"
                                                onClick={() => this.props.selecionaManutencaoVeiculo(this.props.manutencaoVeiculo)}>
                                            <i className="material-icons nav-icon">&#xe872;</i>
                                        </button>
                                        <button type="button" className="btn btn-editar ml-1"
                                                onClick={() => {
                                                    if (this.props.manutencaoVeiculo.selecionado) {
                                                        this.limparSelecaoManutencaoVeiculo();
                                                    } else {
                                                        this.selecionaManutencaoVeiculo(this.props.manutencaoVeiculo)
                                                    }
                                                }}>
                                            <i className="material-icons nav-icon">&#xe150;</i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Autorizacao>
                    </div>
                    <DetalhesManutencaoVeiculo manutencaoVeiculo={this.props.manutencaoVeiculo}/>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        manutencaoVeiculoSelecionado: state.manutencoesVeiculo.manutencaoVeiculoSelecionado        
    });

export default connect(mapStateToProps, {
    changeFieldValue,
    selecionaManutencaoVeiculo,
    alterarExibicaoDetalhamentoManutencaoVeiculo
})(reduxForm({
    form: 'formularioPainelRegistroManutencaoVeiculo'
})(ManutencaoVeiculo));
